import React from "react";
import "./HomeQualidade.css";
import test8 from "../../imagens/imagensTestes/teste8.png";
import { useTranslation } from "react-i18next";

const QualidadeSection = () => {
  const { t } = useTranslation();

  return (
    <section className="qualidade-section p-5">
      <div className="d-flex align-items-center justify-content-center">
        <div className="row align-items-center justify-content-center">

          {/* Imagem */}
          <div className="col-lg-5 col-md-5 col-sm-6 text-center mb-3">
            <img
              src={test8}
              alt={t("homeQualidade.imageAlt")}
              className="qualidade-img "
            />
          </div>

          {/* Texto */}
          <div className="col-lg-6 col-md-8 text-center">
            <h2 className="qualidade-title">
              {t("homeQualidade.title")}
            </h2>

            <p className="qualidade-text">
              {t("homeQualidade.description1")}
            </p>

            <p className="qualidade-text">
              {t("homeQualidade.description2")}
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default QualidadeSection;
